import styled from 'styled-components';
const types = ['All', 'Full-Stack', 'React', 'React Native', 'NodeJS', 'DOM'];
const FilterProjectList = ({ setCatActive, catActive }) => {
  return (
    <List>
      {types.map((type, index) => (
        <List_Item
          key={index}
          className={catActive === type && 'active'}
          onClick={() => setCatActive(type)}>
          {type}
        </List_Item>
      ))}
    </List>
  );
};

export const List = styled.ul`
  display: flex;
  width: 45%;
  margin: 45px 0;
  .active {
    color: rgb(255, 255, 255);
    background-color: rgb(85, 85, 85);
  }
`;
export const List_Item = styled.li`
  border-left: 2px solid rgb(85, 85, 85);
  padding-left: 25px;
  padding-right: 25px;
  line-height: 1.5;
  font-weight: 500;
  z-index: 0;
  color: rgb(85, 85, 85);
  cursor: pointer;
  &:nth-child(1) {
    border-left: none;
  }
  &:hover {
    color: rgb(255, 255, 255);
    background-color: rgb(85, 85, 85);
  }
`;

export default FilterProjectList;
